var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaximize2 = function SvgMaximize2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.519 13.634a.6.6 0 0 1 .848.847l-6.179 6.18h4.726a.6.6 0 1 1 0 1.2H2.741q-.045-.002-.09-.01l-.026-.003q-.04-.01-.077-.024l-.035-.01a1 1 0 0 1-.082-.044l-.022-.01a.6.6 0 0 1-.166-.166q-.016-.026-.03-.054-.014-.025-.026-.053a.6.6 0 0 1-.045-.227v-6.173a.6.6 0 1 1 1.199 0v4.724zM21.26 2.14q.117 0 .227.045.028.012.053.027.028.013.054.03c.16.107.266.29.266.497v6.173a.601.601 0 0 1-1.2 0V4.188l-6.179 6.178a.6.6 0 1 1-.847-.848l6.178-6.178h-4.725a.6.6 0 1 1 0-1.2z"
  })));
};
export default SvgMaximize2;